import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

// Гард маршруту на основі центрального auth-контексту.
// admin трактується як master (доступ до кабінету персоналу) — раніше
// exact-match не пускав адміна на master-роути.
export default function RouteGuard({ children, role }) {
  const { user, loading } = useAuth();

  if (loading) return null;
  if (!user) return <Navigate to="/login" />;

  // admin і superadmin трактуються як master (доступ до кабінету салону).
  const ok =
    !role ||
    user.role === role ||
    (role === "master" &&
      (user.role === "admin" || user.role === "superadmin"));
  if (!ok) return <Navigate to="/" />;

  return children;
}
